import React, { useEffect, useState } from 'react';
// import { Grid } from '@intech/web-ui';
import { CalendarioPagamentoEntidade } from '@entidades';
import { CalendarioPagamentoService } from '@services';

import { BoxCalendario, Dia, Mes, StripedRow } from './styles';
import { LoadingComponent } from '@components';
import { Alert } from '@intech/web-ui';

export const Calendario: React.FC<any> = ({ plano }) => {
  const [calendario, setCalendario] = useState<Array<CalendarioPagamentoEntidade> | null>(null);

  useEffect(() => {
    (async () => {
      var calendario = await CalendarioPagamentoService.BuscarPorPlano(plano.CD_PLANO);
      setCalendario(calendario);
    })();
  }, [plano]);

  if (calendario !== null) {

    if (calendario.length > 0) {
      return (
        <BoxCalendario title={`Calendário de Pagamento de ${calendario[0].NUM_ANO}`}>
          {calendario.map((data: CalendarioPagamentoEntidade, index: number) => {
            return (
              <StripedRow key={index}>
                <Mes>{data.DES_MES}</Mes>
                <Dia>{data.NUM_DIA}</Dia>
              </StripedRow>
            );
          })}
        </BoxCalendario>
      );
    }
    return (
      <Alert type="info">
        {"Calendário de Pagamento não disponível no momento."}
      </Alert>
    );
  }

  return <LoadingComponent />;
}
